module.exports = __webpack_public_path__ + "static/media/logo.0f8ed84b.png";